import React, { Component } from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import style from './ForgetPassword.css';
import FormComponent from '../../components/FormComponent';
import Form from '../../components/Form';
import history from '../../history';

class ForgetPassword extends Component {
  static contextTypes = {
    fetch: PropTypes.func.isRequired
  };

  state = {
    username: '',
    password: '',
    confirmPassword: ''
  };

  onChange = event => {
    event.preventDefault();
    this.setState({ [event.target.name]: event.target.value });
  };

  handleFormSubmit = event => {
    event.preventDefault();
    const { username } = this.state;
    this.context
      .fetch('/api/forget-password', {
        method: 'POST',
        body: JSON.stringify({
          username
        })
      })
      .then(
        () =>
          window.toastr.success('Heads up! You will receive an email shortly.'),
        this.setState({ username: '' })
      )
      .catch(() => window.toastr.error('Email failed to send!'));
  };

  handleResetPassword = event => {
    event.preventDefault();
    const { id: token } = this.props;
    const { password, confirmPassword } = this.state;
    if (password !== confirmPassword) {
      window.toastr.error('Password do not match!');
    } else {
      this.context
        .fetch('/api/reset-password', {
          method: 'POST',
          body: JSON.stringify({
            password,
            token
          })
        })
        .then(
          () => window.toastr.success('Password successfully reset!'),
          history.push('/login')
        )
        .catch(() => window.toastr.error('Email failed to send!'));
    }
  };

  render() {
    const { id } = this.props;
    const { username, password, confirmPassword } = this.state;
    if (id) {
      return (
        <Form
          title="Change My Password"
          onFormSubmit={this.handleResetPassword}
        >
          <h3>Change the Password?</h3>
          <p>Please pick a new password.</p>
          <br />
          <div className={style.field}>
            <i className={cx(style.icon, 'fa', 'fa-lock')} />
            <FormComponent
              name="password"
              type="password"
              pattern="(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9]).{8,}"
              title="Eight or more characters with at least 1 lower case, 1 upper case, and 1 number"
              value={password}
              onChange={this.onChange}
              placeholder="New Password"
              required
            />
            <div className={style.iconPlaceholder} />
          </div>
          <div className={style.field}>
            <i className={cx(style.icon, 'fa', 'fa-repeat')} />
            <FormComponent
              name="confirmPassword"
              type="password"
              pattern="(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9]).{8,}"
              title="Eight or more characters with at least 1 lower case, 1 upper case, and 1 number"
              value={confirmPassword}
              onChange={this.onChange}
              placeholder="Repeat Password"
              required
            />
            <div className={style.iconPlaceholder} />
          </div>
        </Form>
      );
    }
    return (
      <Form title="Reset My Password" onFormSubmit={this.handleFormSubmit}>
        <h3>Forget the Password?</h3>
        <p>Please, type your email address here.</p>
        <br />
        <div className={style.field}>
          <i className={cx(style.icon, 'fa', 'fa-envelope')} />
          <FormComponent
            name="username"
            type="email"
            value={username}
            onChange={this.onChange}
            placeholder="email"
            required
          />
          <div className={style.iconPlaceholder} />
        </div>
      </Form>
    );
  }
}

export default withStyles(style)(ForgetPassword);



// WEBPACK FOOTER //
// ./src/routes/forgetPassword/ForgetPassword.js